import {
  createMongoAbility
} from "@casl/ability";
function buildTeammateAuthorization(roleAccess) {
  return createMongoAbility(
    roleAccess || []
  );
}
export {
  buildTeammateAuthorization
};
//# sourceMappingURL=teammateAuthorizationHelpers.js.map
